export default __webpack_public_path__ + "static/media/delete-action-trash.cdb0adf2.svg";